import React from "react"

import Layout2 from "../components/layout2"
import SEO from "../components/seo"

import InternLinks from "../components/internlinks";
import { FaCheck } from 'react-icons/fa';
import { Breadcrumb } from "../components/globals/breadcrumb";

const IndexPage = () => (
  <Layout2>
    <Breadcrumb category={["recensioner", "recensioner"]} page={["Dentaworks", "dentaworks"]}/>
     <SEO title="Dentaworks" description="Recension av Dentaworks"/>
     <section className="section-produkter">
       <article>
       <div className="prod-text">
          <h1>Vita tänder med Dentaworks</h1>
         </div>
      </article>
      <article class="right">
        <img src="../tandblekning-dw.jpg" alt="Dentaworks Tandblekning"/>
        <aside>
           <h3 class="erbj-pris">598:-</h3><span class="ord-pris">(898:-)</span>
          <h2>Dentaworks Plus</h2>
          <p>Innehåller både gel och skenor för tandblekning hemma och en tandblekningspenna som du lätt kan ta med dig överallt.</p>
          <a href="https://adtr.co/vSPMtw" target="_blank" rel="noopener noreferrer" class="btn btn-warning btn-width">Beställ här</a>
          <ul>
             <li><FaCheck className="li-icon" /> Tandblekningsgel 20ml (56 behandlingar)</li>
             <li><FaCheck className="li-icon" /> Tandblekningpenna 4ml</li>
             <li><FaCheck className="li-icon" /> 3 st Soft tandskenor</li>
          </ul>
        </aside>
        <div className="prod-text"><h3>Dentaworks tandblekning</h3>
         <p>Dentaworks tandblekningsgel 20 ml som räcker till ca 56 behandlingar. 3st Dentaworks Soft tandskenor samt 
           förvaringsbox för tandskenorna. En manual med enkla instruktioner samt en tandnyanskarta för att lättare se resultat.</p></div>
       </article>
       <article>
        <div className="prod-text"><h3>Om dentaworks</h3>
        <p>En smidig lösning med dentaworks är att dom har Klarna som betalningsmetod. Normal leveranstid är 1-2 dagar. Dentaworks tandskenor kan upplevas lite
          mjukare och skönare att ha i munnen. </p>
                    <p>Dentaworks produkter är veganska och inte testade på djur.</p>
                    <p>På deras site finns det även mycket andra bra produkter för att sköta din tandhygien. Tex, tungskrapa, 
          tandstensverktyg, munspegel.</p>
          <a href="https://adtr.co/5Pv4vA" target="_blank" rel="noopener noreferrer">Se alla deras produkter här</a>
          
          </div>
      </article>
       </section>
       {/* <section className="section-cards">
    <main>
    <h2 class="rubrik-tandblekning">Bästa tandblekningen hemma</h2>
       <Card />
       </main>
  </section> */}
  <section className="section-cards card-height">
  <main>
      <h2 class="internal-rubrik">Bästa tandblekningen hemma</h2>
    <InternLinks />
    </main>
    
  </section>
  <main className="section-info">
         <section className="section-info">
        <div className="prod-text"><h3>Om Dentaworks Soft tandskenor</h3>
        <p>Vad är skillnaden mellan Dentaworks Soft tandskenor och andra tandskenor? </p><p>Skillnaden ligger i den speciella kristallklara plasten som används i Dentaworks Soft tandskenor. Se till att ditt tandblekningskit innehåller helt transparanta tandskenor så du kan se tänderna och gelén under blekningsprocessen. Den speciella plasten gör Dentaworks tandskenor mjukare och skönare att ha i munnen. En annan unik fördel är att våra tandskenor kan omformas hur många gånger som helst om det skulle behövas. De är också enklare att forma efter tänderna än andra tandskenor.</p>
          <a href="https://adtr.co/5Pv4vA" target="_blank" rel="noopener noreferrer">Se alla deras produkter här</a>
          
          </div>
          <p></p><p></p><p></p>
      </section>
      </main>
  </Layout2>
)

export default IndexPage
